<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">
        Button
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--modifier-height">
  <h2>Customized Button</h2>
  <div class="content__tools-wrap">
    <div class="content__row">
      <label for="color" class="content__row-label">color</label>
      <select [(ngModel)]="color" id="color" placeholder="Color" name="color" class="c-input-group__control">
        <ng-container *ngFor="let color of colorList">
          <option [value]="color">{{ color }}</option>
        </ng-container>
      </select>
      <label for="size" class="content__row-label">size</label>
      <select [(ngModel)]="size" id="size" placeholder="Size" name="Size" class="c-input-group__control">
        <ng-container *ngFor="let size of sizeList">
          <option [value]="size">{{ size }}</option>
        </ng-container>
      </select>
      <label for="shape" class="content__row-label">shape</label>
      <select [(ngModel)]="shape" id="shape" placeholder="Shape" name="Shape" class="c-input-group__control">
        <ng-container *ngFor="let shape of shapeList">
          <option [value]="shape">{{ shape }}</option>
        </ng-container>
      </select>
      <label for="button" class="content__row-label">button</label>
      <select [(ngModel)]="buttonType" id="button" placeholder="Button Type" name="Button" class="c-input-group__control">
        <ng-container *ngFor="let buttonType of buttonTypeList">
          <option [value]="buttonType">{{ buttonType }}</option>
        </ng-container>
      </select>
      <label for="type" class="content__row-label">type</label>
      <select [(ngModel)]="type" id="type" placeholder="Type" name="Type" class="c-input-group__control">
        <ng-container *ngFor="let type of typeList">
          <option [value]="type">{{ type }}</option>
        </ng-container>
      </select>
      <label for="target" class="content__row-label">target</label>
      <select [(ngModel)]="target" id="target" placeholder="Target" name="Target" class="c-input-group__control">
        <ng-container *ngFor="let target of targetList">
          <option [value]="target">{{ target }}</option>
        </ng-container>
      </select>
      <label for="position" class="content__row-label">position</label>
      <select [(ngModel)]="position" id="position" placeholder="Icon Position" name="Icon" class="c-input-group__control">
        <ng-container *ngFor="let position of positionList">
          <option [value]="position">{{ position }}</option>
        </ng-container>
      </select>
    </div>
    <div class="content__row">
      <div class="c-input-check-inline">
        <input id="isOutline" class="c-input-check-inline__input" type="checkbox" name="isOutline"
          [(ngModel)]="isOutline">
        <label for="isOutline" class="c-input-check-inline__label">Has Outline</label>
      </div>
      <div class="c-input-check-inline">
        <input id="disabled" class="c-input-check-inline__input" type="checkbox" name="disabled" [(ngModel)]="disabled">
        <label for="disabled" class="c-input-check-inline__label">Disabled</label>
      </div>
      <div class="c-input-check-inline">
        <input id="hasQueryParams" class="c-input-check-inline__input" type="checkbox" name="hasQueryParams"
          [(ngModel)]="hasQueryParams">
        <label for="hasQueryParams" class="c-input-check-inline__label">Has Query Params</label>
      </div>
    </div>
    <div class="content__row">
      <input id="label" class="c-input-group__control" placeholder="Label" type="text" name="label" aria-label="label" [(ngModel)]="label">
      <label for="label" class="u-display-none">label</label>
      <input id="url" class="c-input-group__control" placeholder="Url" type="text" name="url" aria-label="url" [(ngModel)]="url">
      <label for="url" class="u-display-none">url</label>
      <input id="icon" class="c-input-group__control" placeholder="Icon" type="text" name="icon" aria-label="icon" [(ngModel)]="icon">
      <label for="icon" class="u-display-none">icon</label>
      <input id="tooltip" class="c-input-group__control" placeholder="Tooltip" type="text" name="tooltip" aria-label="tooltip"
        [(ngModel)]="tooltip">
        <label for="tooltip" class="u-display-none">tooltip</label>
      <input id="ariaLabel" class="c-input-group__control" placeholder="Aria Label" type="text" name="ariaLabel" aria-label="ariaLabel"
        [(ngModel)]="ariaLabel">
        <label for="ariaLabel" class="u-display-none">ariaLabel</label>
    </div>
  </div>
  <ng-container *ngIf="isBrowser">
    <form action="/button" method="get" id="form1">
      <maced-button buttonId="buttonId" [color]="color" [size]="size" [shape]="shape" [buttonType]="buttonType" [placement]="selectedPlacement"
        [type]="type"  [hasSpan]="hasSpan" [spanClass]="spanClass" [target]="target" [position]="position" [isOutline]="isOutline" [disabled]="disabled" tootipButtonId = "tootipButtonId" formId="form1" [queryParams]="hasQueryParams ? queryParams : {}" [label]="((hasSpinner && !icon) || color==='ghost')?'':label" [url]="!hasSpinner?url:''" [icon]="!hasSpinner?icon:''"
        [tooltip]="!hasSpinner?tooltip:''" [ariaLabel]="!hasSpinner?ariaLabel:''" name="buttonName" value="val1" spinnerLabelId="spinnerLabelId">
      </maced-button>
    </form>

    <h2>Button with spinner</h2>

    <maced-button buttonId="buttonId" [color]="color" [size]="size" [shape]="shape" [buttonType]="buttonType"
    [type]="type" [target]="target" [position]="position" [isOutline]="isOutline" [disabled]="disabled" tootipButtonId = "tootipButtonId" formId="form1" [queryParams]="hasQueryParams ? queryParams : {}" name="buttonName" value="val1" [spinner]="true" spinnerLabelId="spinnerLabelId">
  </maced-button>

  </ng-container>
  <ng-container *ngIf="!isBrowser">
    <h2>Button with Form</h2>
    <form action="/button" method="get" id="form1">
      <maced-button buttonId="buttonId" [color]="color" [size]="size" [shape]="shape" [buttonType]="buttonType"
        [type]="type" [target]="target" [position]="position" [isOutline]="isOutline" [disabled]="disabled" tootipButtonId = "tootipButtonId" formId="form1" [queryParams]="hasQueryParams ? queryParams : {}" [label]="label" [url]="url" [icon]="icon"
        [tooltip]="tooltip" [ariaLabel]="ariaLabel" name="buttonName" value="val1">
      </maced-button>
    </form>
    <h2>Button without Form</h2>
    <maced-button buttonId="buttonId" [color]="color" [size]="size" [shape]="shape" [buttonType]="buttonType"
      [type]="type" [target]="target" [position]="position" [isOutline]="isOutline" [disabled]="disabled" tootipButtonId = "tootipButtonId" [queryParams]="hasQueryParams ? queryParams : {}" [label]="label" [url]="url" [icon]="icon" [tooltip]="tooltip"
      [ariaLabel]="ariaLabel" name="buttonName" value="val1">
    </maced-button>
  </ng-container>
</div>